import React from "react"
import { render, fireEvent, cleanup } from "@testing-library/react"
import SidebarNav from "../SidebarNav"

// stub out window object for tests to pass - required for react-md
beforeAll(() => {
  Object.defineProperty(window, "matchMedia", {
    value: jest.fn(() => {
      return {
        matches: true,
        addEventListener: jest.fn(),
        removeEventListener: jest.fn()
      }
    })
  })
})

afterEach(cleanup)

describe("<SidebarNav />", () => {
  const primaryLinkData = [
    {
      linkName: "Admin",
      href: "/admin/",
      iconName: "admin",
      isActive: true
    }
  ]

  const secondaryLinkData = [
    {
      title: "Tenants",
      children: [{ title: "My Tenants", href: "/my/tenants" }]
    }
  ]

  it("properly displays primary links", () => {
    const { getByText } = render(
      <SidebarNav
        associatedContentSelector="#mainContent"
        primaryLinkData={primaryLinkData}
        secondaryLinkData={null}
      />
    )
    expect(getByText("Admin")).toBeInTheDocument()
  })
  it("properly displays secondary links", () => {
    const { queryByText } = render(
      <SidebarNav
        associatedContentSelector="#mainContent"
        primaryLinkData={primaryLinkData}
        secondaryLinkData={secondaryLinkData}
      />
    )

    expect(queryByText("Tenants")).toBeInTheDocument()
    expect(queryByText("My Tenants")).toBeInTheDocument()
  })
  it("properly hides secondary links", () => {
    const { queryByText } = render(
      <SidebarNav
        associatedContentSelector="#mainContent"
        primaryLinkData={primaryLinkData}
        secondaryLinkData={secondaryLinkData}
        isSidebarExpandedByDefault={false}
      />
    )
    expect(queryByText("Tenants")).not.toBeInTheDocument()
  })
  it("properly hides secondary links when sidebar is collapsed", () => {
    const { queryByText } = render(
      <SidebarNav
        associatedContentSelector="#mainContent"
        primaryLinkData={primaryLinkData}
        secondaryLinkData={secondaryLinkData}
      />
    )

    const collapseMenu = queryByText("Collapse menu")
    fireEvent.click(collapseMenu)

    expect(queryByText("Tenants")).not.toBeInTheDocument()

    const collapseMenuClosed = queryByText("Collapse menu")
    expect(collapseMenuClosed).not.toBeInTheDocument()
  })
  it("properly shows secondary links when sidebar is expanded", () => {
    const { queryByText } = render(
      <SidebarNav
        associatedContentSelector="#mainContent"
        primaryLinkData={primaryLinkData}
        secondaryLinkData={secondaryLinkData}
        isSidebarExpandedByDefault={false}
      />
    )

    const openMenu = queryByText("keyboard_arrow_right")
    fireEvent.click(openMenu)

    expect(queryByText("Tenants")).toBeInTheDocument()
    expect(queryByText("Collapse menu")).toBeInTheDocument()
  })
})
